import React from 'react'
import { Box, useTheme } from '@mui/material'
import { BarChart } from '@mui/x-charts/BarChart'

interface HistogramData {
  label: string
  count: number
  value: number
}

interface LegendHistogramProps {
  data: HistogramData[]
  title?: string
  height?: number
  color?: string
}

const LegendHistogram: React.FC<LegendHistogramProps> = ({
  data,
  height = 200,
  color,
}) => {
  const theme = useTheme()

  const defaultColor = color || theme.palette.primary.main

  const [yAxisData, seriesData] = React.useMemo(() => {
    const labels: string[] = []
    const counts: number[] = []
    for (const item of data) {
      labels.push(item.label)
      counts.push(item.count)
    }
    return [labels, counts]
  }, [data])

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Box sx={{ width: '100%', height }}>
        <BarChart
          layout="horizontal"
          hideLegend={true}
          height={height}
          borderRadius={2}
          series={[
            {
              layout: 'horizontal',
              data: seriesData,
              minBarSize: 1,
              color: defaultColor,
              label: 'Count',
            },
          ]}
          yAxis={[
            {
              data: yAxisData,
              position: 'right',
              tickSize: 0,
              scaleType: 'band' as const,
              disableLine: true,
              tickLabelStyle: {
                fontSize: 14,
                fill: theme.palette.text.secondary,
              },
            },
          ]}
          xAxis={[
            {
              reverse: true,
              position: 'none',
              tickLabelStyle: {
                fontSize: 10,
                fill: theme.palette.text.secondary,
              },
            },
          ]}
          grid={{
            horizontal: false,
            vertical: false,
          }}
          axisHighlight={{
            x: 'band',
            y: 'none',
          }}
        />
      </Box>
    </Box>
  )
}

export default LegendHistogram
